import { DATE_FORMAT, TIME_FORMAT } from '../constants/appConstants';
import { WIN_STATUS, WIN_TYPES, TRACK_TYPES } from '../constants/winConstants';
import moment from 'moment';

/**
 * define field domain object, where 
 *      key: the field name
 *      value: the domain object for that field
 */
const FIELD_DOMAINS = {
    trackType: TRACK_TYPES,
    winType: WIN_TYPES
};

export default class TrackWindow {
    constructor() {
        this.objectId = 'tmp' + Date.now();
        this.bDiv = '';
        this.subdiv = '';
        this.lineSegment = '';
        this.bmp = '';
        this.emp = '';
        this.bmpSuf = '';
        this.empSuf = '';
        this.bcp = '';
        this.ecp = '';
        this.trackType = '';
        this.trackNum = '';
        this.trackList = [];
        this.startDate = '';
        this.startTime = '';
        this.duration = '';
        this.gangIds = '';
        this.winType = '';
        this.guids = [];
        this.comment = '';
        this.status = '';
        this.rejectionCode = '';
        this.rejectionComment = '';
        this.cancellationCode = '';
        this.cancellationComment = '';
        this.flocs = [];
        // this.isFinal = true;
        // this.violations = [];
    }

    fromQueryService(tw) {
        this.objectId = tw.trackWindowRequestID && tw.trackWindowRequestID.toUpperCase();
        this.bDiv = tw.beginDivision && tw.beginDivision.name && tw.beginDivision.name.trim();
        this.subdiv = tw.beginSubDivision && tw.beginSubDivision.name && tw.beginSubDivision.name.trim();
        this.trackList = tw.trackList;

        if (tw.beginningLocation) {
            this.lineSegment = tw.beginningLocation.lineSegment;
            this.bmp = tw.beginningLocation.milepost;
            this.bmpSuf = tw.beginningLocation.milepostSuffix ? 
                tw.beginningLocation.milepostSuffix.trim().toUpperCase() : '';
        }

        if (tw.endingLocation) {
            this.emp = tw.endingLocation.milepost;
            this.empSuf = tw.endingLocation.milepostSuffix ? 
                tw.endingLocation.milepostSuffix.trim().toUpperCase() : '';
        }

        this.bcp = tw.beginningControlPoint ? tw.beginningControlPoint.trim() : '';
        this.ecp = tw.endingControlPoint ? tw.endingControlPoint.trim() : '';

        if (tw.track) {
            this.trackType = tw.track.type.trim();
            this.trackNum = tw.track.number.trim();
        }
        
        if (tw.startDate && tw.startTime) {
            const st = moment(tw.startDate + ' ' + tw.startTime);
            this.startDate = st.format(DATE_FORMAT);
            this.startTime = st.format(TIME_FORMAT);
        }

        this.duration = tw.trkWinDur;
        this.gangIds = tw.gangId;
        this.winType = tw.type && tw.type.code;
        this.guids = tw.guids;

        if (tw.comments && tw.comments.length > 0) {
            // two types of comments:
            //  - GC: track comment
            //  - TC: transportation comment
            // Here need to display the track comments
            let trkComments = tw.comments.filter(aComm => aComm.type === 'GC');
            this.comment = trkComments.length> 0 ? trkComments[0].comment : '';
        }
        
        this.status = tw.trkWinReqSbmDesc && tw.trkWinReqSbmDesc.toUpperCase();

        if (this.status === WIN_STATUS.REJECTED) {
            this.rejectionCode = tw.rejectionCode || '';
            this.rejectionComment = tw.rejectionComment || '';
        } else if (this.status === WIN_STATUS.CANCELLED) {
            this.cancellationCode = tw.cancellationCode || '';
            this.cancellationComment = tw.cancellationComment || '';
        }

        this.flocs = tw.flocs || [];
    }

    fromCreateUpdateService(tw) {
        let beginDivision = tw.begDivisions[0];
        let beginSubDivision = beginDivision && beginDivision.subDivisions[0];
        this.objectId = tw.trkWinReqId && tw.trkWinReqId.toUpperCase();
        this.bDiv = beginDivision && beginDivision.divisionName && beginDivision.divisionName.trim();
        this.subdiv = beginSubDivision && beginSubDivision.subDivisionName && beginSubDivision.subDivisionName.trim();
        this.trackList = tw.trackList;
        this.lineSegment = tw.lineSeg;
        this.bmp = tw.begMp;
        this.bmpSuf = tw.begMpSfx ? tw.begMpSfx.trim().toUpperCase() : '';
        this.emp = tw.endMp;
        this.empSuf = tw.endMpSfx ? tw.endMpSfx.trim().toUpperCase() : '';
        this.bcp = tw.bgnCntrlPoint ? tw.bgnCntrlPoint.trim() : '';
        this.ecp = tw.endCntrlPoint ? tw.endCntrlPoint.trim() : '';
        this.trackType = tw.trkType.trim();
        this.trackNum = tw.trkNbr.trim();

        if (tw.winDt && tw.startTime) {
            const st = moment(tw.winDt + ' ' + tw.startTime);
            this.startDate = st.format(DATE_FORMAT);
            this.startTime = st.format(TIME_FORMAT);
        }

        this.duration = tw.duration;
        this.gangIds = tw.gangId;
        this.winType = tw.winType;
        this.guids = tw.guids;
        this.flocs = tw.flocs || [];
        this.comment = tw.comments.trim();        
        this.status = tw.winReqSbm && tw.winReqSbm.toUpperCase();
    }

    fromMock(tw) {
        this.objectId = tw.OBJECTID && tw.OBJECTID.toUpperCase();
        this.bDiv = tw.beginDivName && tw.beginDivName.trim();
        this.subdiv = tw.GY_SDIV && tw.GY_SDIV.trim();
        this.lineSegment = tw.LINE_SEG_NBR;
        this.bmp = tw.MILE_POST_BEG;
        this.emp = tw.MILE_POST_END;
        this.bmpSuf = tw.MILE_POST_BEG_SFX ? tw.MILE_POST_BEG_SFX.trim().toUpperCase() : '';
        this.empSuf = tw.MILE_POST_END_SFX ?  tw.MILE_POST_END_SFX.trim().toUpperCase() : '';
        this.bcp = tw.BEGIN_CONTROL_POINT ? tw.BEGIN_CONTROL_POINT.trim() : '';
        this.ecp = tw.END_CONTROL_POINT ? tw.END_CONTROL_POINT.trim() : '';
        this.trackType = tw.TRACK_TYPE;
        this.trackNum = tw.TRACK_SDTK_NBR;
        this.startDate = tw.START_DATE  ? tw.START_DATE.split(' ')[0] : '';
        this.startTime = tw.START_DATE ? tw.START_DATE.split(' ')[1].slice(0, 5) : '';
        this.duration = tw.DURATION;
        this.gangIds = tw.GANG_ID;
        this.winType = tw.TYPE;
        this.guids = tw.GUIDS;
        this.comment = tw.COMMENT;
        this.status = tw.Status && tw.Status.toUpperCase();
    }

    clone() {
        let newWin = new TrackWindow();
        newWin.fromJson(this.toJson());

        return newWin;
    }

    fromJson(json) {
        const inWin = JSON.parse(json);
        Object.keys(inWin).forEach((key) => this[key] = inWin[key], this);
    }

    toJson() {
        return JSON.stringify(this);
    }

    toServiceRequest() {
        let winClone = this.applySwitchYes();

        return {
            "trkWinReqId": winClone.objectId.indexOf('tmp') > -1 ? '' : winClone.objectId,
            "gangId": winClone.gangIds,
            "winType": winClone.winType,
            "lineSeg": winClone.lineSegment,
            "begMp": winClone.bmp,
            "begMpSfx": winClone.bmpSuf,
            "endMp": winClone.emp,
            "endMpSfx": winClone.empSuf,
            "bgnCntrlPoint": winClone.bcp,
            "endCntrlPoint": winClone.ecp,
            "trkType": winClone.trackType,
            "trkNbr": winClone.trackNum,
            "trackList": winClone.trackList,
            "winDt": winClone.startDate,
            "startTime": winClone.startTime + ":00",
            "duration": winClone.duration,
            "comments": winClone.comment,
            "flocs": winClone.flocs,
            // "isFinal": winClone.isFinal,     // only needed when required to capture violations for intermediate windows
            "violations": winClone.violations && winClone.violations.length > 0 ? this.transformViolations(winClone) : []
        }
    }

    /**
     * Apply switch yes result to prepare the window for service calls
     * @returns a clone of the window object with switch yes applied
     */
    applySwitchYes() {
        let winClone = this.clone();

        if (winClone.switchYes) {
            //  1. update bmp, emp, bcp and ecp with the switch yes response
            if (winClone.switchYes.beginMilepost) {
                winClone.bmp = winClone.switchYes.beginMilepost.milepost;
                winClone.bmpSuf = winClone.switchYes.beginMilepost.milepostSuffix || '';
            }

            if (winClone.switchYes.endMilepost) {
                winClone.emp = winClone.switchYes.endMilepost.milepost;
                winClone.empSuf = winClone.switchYes.endMilepost.milepostSuffix || '';
            }           
        }

        return winClone;
    }

    transformViolations(win) {
        var transformedViolations = [];

        win.violations.forEach(v => {
            var violation =  {
                "ruleId":v.ruleId,
                "ruleType":v.warningType,
                "violationMessage":v.message  
            }
            transformedViolations.push(violation)
        });

        return transformedViolations
    }

    isMyWindow(bid) {
        return this.objectId.includes(bid);
    }

    isMultiTrackWindow() { 
        return this.trackList && this.trackList.length > 0;
    }
    
    isApproved() { 
        return this.status === WIN_STATUS.APPROVED;
    }
    
    isPending() {
        return this.status === WIN_STATUS.PENDING;
    }
    
    isRejected() { 
        return this.status === WIN_STATUS.REJECTED;
    }

    isCancelled() {
        return this.status === WIN_STATUS.CANCELLED;
    }

    // Requirement: 
    //  FLS can ONLY edit/delete windows the user owns
    //  FLS cannot edit/delete approved windows
    //  FLS cannot create/edit/delete windows planned for current week
    //  FLS cannot create/edit/delete windows planned for next week after Wednesday at midnight
    canEdit(bid) {
        const todayWeekDay = moment().day();
        const startDate = moment(this.startDate);

        return this.isMyWindow(bid) 
            && !this.isApproved() 
            && startDate.isAfter(moment().day(todayWeekDay < 3 ? 6 : 13));
    }

    canCopy() {
        return this.isApproved() || this.isPending();
    }
    
    toDisplay() { 
        let tracks = "";

        if (this.trackList.length > 0) {
            tracks = this.trackList.map(trk => {
                const [trackTypeCode, clic] = trk.split('-');
                const trackTypeName = TrackWindow.toFieldDisplayValue('trackType', trackTypeCode);

                return [trackTypeName, clic].join(' ');
            }).join(', ');
        }
        else {
            let descriptiveTrackType = TrackWindow.toFieldDisplayValue('trackType', this.trackType);
            tracks = descriptiveTrackType + ' ' + this.trackNum;
        }

        let objDisplay = {
            // 'OBJECTID': this.objectId,
            'GANG ID': this.gangIds,
            'TYPE': TrackWindow.toFieldDisplayValue('winType', this.winType),
            'DATE': this.startDate,
            'TIME': this.startTime,
            'DURATION': this.duration,
            'LINE SEGMENT': this.lineSegment,
            'BEGIN MP': this.bmp + this.bmpSuf,
            'END MP': this.emp + this.empSuf,
            'BEGIN CP': this.bcp,
            'END CP': this.ecp,
            'TRACKS': tracks,
            'COMMENT': this.comment
        };

        if (this.status === WIN_STATUS.REJECTED) {
            objDisplay['REJECTION CODE'] = this.rejectionCode;
            objDisplay['REJECTION COMMENT'] = this.rejectionComment;
        } else if (this.status === WIN_STATUS.CANCELLED) {
            objDisplay['CANCELLATION CODE'] = this.cancellationCode;
            objDisplay['CANCELLATION COMMENT'] = this.cancellationComment;
        }

        return objDisplay;
    }

    static toFieldDisplayValue(fldName, fldValue) {
        const fldDomain = FIELD_DOMAINS[fldName];

        return fldDomain ? fldDomain[fldValue] : fldValue;
    }

    /**
     * Compare two track windows
     * @param {TrackWindow} a 
     * @param {TrackWindow} b 
     * @returns 1 if a > b; -1 if a < b; 0 if a = b
     * @description used to sort the list of windows
     */
    static compare(a, b) {
        const aStartDate = moment(a.startDate);
        const bStartDate = moment(b.startDate);
        const compareStartDate = aStartDate.isAfter(bStartDate) ? 1 
            : aStartDate.isBefore(bStartDate) ? -1 : 0;
        
        const compareLS = a.lineSegment > b.lineSegment ? 1 
            : a.lineSegment < b.lineSegment ? -1 : 0;

        const compareBMP = a.bmp > b.bmp ? 1 : a.bmp < b.bmp ? -1 : 0;

        return compareStartDate || compareLS || compareBMP;
    }
}